import React, { useEffect, useState } from "react";
import MsgWithApplicantPopup from "./MsgWithApplicantPopup";
import Moment from "react-moment";
import MessagingPopup from "./MessagingPopup";
import { useDispatch, useSelector } from "react-redux";
import { addAppNewMessage, appMessageAdded, getAddedMessageStatus, getAppMessages, getMsgDocSasUrls, loadAppMessages, sendMessageThroughEmail, getMessagesLoading } from "../../app/store/messages";
import { getAlert } from "../../services/appAlerts";
import { getCurrentUser } from "../../app/store/auth";
import { getComponentUpdateStatus } from "../../app/store/tools";
import { uploadFileToBlob } from "../../services/blobUploadService";
import { getWfPhasesColor } from "../../services/appService";

const MessageWithApplicant = (props) => {
  const { workflowTask, handleUpdateComponent } = props;
  const [appMessages, setAppMessages] = useState([]);
  const [selectedMessage, setSelectedMessage] = useState({});
  const [selectedKey, setSelectedKey] = useState("home");
  const [selectedMsgId, setSelectedMsgId] = useState(0);
  const [updateCompStatus, setUpdateCompStatus] = useState(false);
  const [docs, setDocs] = useState([]);

  const appMessagesSelector = useSelector(getAppMessages);
  const addedMessageStatus = useSelector(getAddedMessageStatus);
  const componentUpdateStatusSelector = useSelector(getComponentUpdateStatus);
  const msgDocSasUrlsSelector = useSelector(getMsgDocSasUrls);
  const isLoading = useSelector(getMessagesLoading);

  const dispatch = useDispatch();
  const currentUser = getCurrentUser();

  useEffect(() => {
    if (workflowTask?.ciid > 0) {
      dispatch(loadAppMessages(workflowTask.ciid, currentUser.id));
    }
  }, []);

  useEffect(() => {
    if (appMessagesSelector.length > 0) {
      setAppMessages(appMessagesSelector);
      let msgItems = "";
      appMessagesSelector.filter(x => x.senderRole === "new").map((com, pkey) => {
        if (pkey > 0) msgItems += ",";
        com.msgIds.map((x, key) => {
          if (key > 0) msgItems += ",";
          msgItems += x;
        })
      })
      if (updateCompStatus && msgItems !== "") {
        handleUpdateComponent(msgItems);
      }
      setUpdateCompStatus(false);
    }
  }, [appMessagesSelector]);

  useEffect(() => {
    if (addedMessageStatus && workflowTask?.ciid) {
      getAlert("", "Sent Successfully", "success");
      dispatch(loadAppMessages(workflowTask.ciid, currentUser.id));
      setUpdateCompStatus(true);
      setSelectedKey("home");
    }
  }, [addedMessageStatus])


  const handleAddNewMessage = async (Msg, docs, msgType) => {
    setDocs(docs);
    const wfTask = { ...workflowTask };
    wfTask.performerId = currentUser.id;
    const frmdata = new FormData();
    frmdata.append("task", JSON.stringify(wfTask));
    frmdata.append("Msg", Msg);
    frmdata.append("MsgType", msgType);
    //docs.map((file, key) => frmdata.append("files[" + key + "]", file.file));
    frmdata.append("files", JSON.stringify(docs.map((file) => {
      return {
        name: file.name,
        type: file.type,
        size: file.size
      }
    })));
    dispatch(addAppNewMessage(frmdata));
    dispatch(sendMessageThroughEmail(frmdata));

  };


  useEffect(() => {
    const uploadAllDocuments = async () => {
      if (msgDocSasUrlsSelector?.length > 0) {
        try {
          await Promise.all(
            docs.map((file, key) =>
              uploadFileToBlob(
                file.file,
                msgDocSasUrlsSelector[key]?.uploadUrl,
                (progress) => {
                  console.log(`Upload progress: ${progress}%`);
                }
              )
            )
          );

          // Runs only after ALL uploads finish   
          console.log("All files uploaded successfully!");
          dispatch(appMessageAdded({ sasUrls: null }));
          setDocs([]);
        } catch (error) {
          console.error("Upload failed:", error);
        }
      }
    };

    uploadAllDocuments();
  }, [msgDocSasUrlsSelector]);


  const handleSelectTab = (tab) => {
    setSelectedKey(tab);
  }

  const handleResetSelection = () => {
    setSelectedMsgId(0);
    setSelectedMessage(null);
  }

  const handleSelectMessage = (msg) => {
    if (selectedMsgId === msg.id) {
      handleResetSelection();
    } else {
      setSelectedMessage(msg);
      setSelectedMsgId(msg.id);
    }
  }

  const handleReadStatus = (msgItems) => {
    if (msgItems !== "") {
      handleUpdateComponent(msgItems);
      setUpdateCompStatus(true);
    }
  }

  const renderSelectedMessageCard = (mode = "messages") => {
    if (selectedMsgId === 0 || !selectedMessage) return null;

    return (
      <div className="rt-msg-selected-card">
        <div className="rt-msg-selected-info">
          <div className="rt-msg-selected-avatar">
            {(selectedMessage.createdBy || "?").charAt(0).toUpperCase()}
          </div>
          <div className="rt-msg-selected-meta">
            <strong>{selectedMessage.createdBy || "Selected Message"}</strong>
            <span>
              <i className="fa fa-comments-o" aria-hidden="true" />
              Thread #{selectedMsgId}
              {selectedMessage.email && (
                <>
                  <span>&bull;</span>
                  <i className="fa fa-envelope-o" aria-hidden="true" />
                  {selectedMessage.email}
                </>
              )}
            </span>
          </div>
        </div>
        <div className="rt-msg-selected-actions">
          {mode === "reply" ? (
            <button
              className="rt-msg-action-btn"
              onClick={() => handleSelectTab("home")}
              type="button"
            >
              <i className="fa fa-arrow-left" aria-hidden="true" /> Back to Messages
            </button>
          ) : (
            <button
              className="rt-msg-action-btn is-primary"
              onClick={() => handleSelectTab("msgList")}
              type="button"
            >
              <i className="fa fa-reply" aria-hidden="true" /> View / Reply
            </button>
          )}
          <button
            className="rt-msg-action-btn btn-danger-search"
            onClick={handleResetSelection}
            type="button"
            title="Clear selection"
            style={{ padding: "8px 12px" }}
          >
            <i className="fa fa-times" aria-hidden="true" />
          </button>
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (componentUpdateStatusSelector && updateCompStatus) {
      if (workflowTask?.ciid > 0) {
        dispatch(loadAppMessages(workflowTask.ciid, currentUser.id));
        setUpdateCompStatus(false);
      }
    }
  }, [componentUpdateStatusSelector])

  return (
    <React.Fragment>
      <div className="rt-message-workbench">
        <style>{`
          .rt-message-workbench {
            background: transparent !important;
            color: #334155 !important;
            --task-accent: #2563eb !important;
            --task-soft: #eff6ff !important;
            --primary-color: #2563eb;
            --primary-hover: #1d4ed8;
            --primary-soft: #eff6ff;
            --secondary-color: #64748b;
            --secondary-hover: #475569;
            --border-color: #e2e8f0;
            --bg-light: #f8fafc;
            --text-main: #1e293b;
            --text-muted: #64748b;
            font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
          }

          @keyframes loadingBar {
            0%   { width: 0%; opacity: 1; }
            70%  { width: 85%; opacity: 1; }
            100% { width: 100%; opacity: 0; }
          }

          .wf-loading-bar {
            position: absolute !important;
            top: 0 !important;
            left: 0 !important;
            right: 0 !important;
            height: 3px !important;
            background: linear-gradient(90deg, #2563eb, #7c3aed, #2563eb) !important;
            background-size: 200% 100% !important;
            animation: loadingBar 1.6s ease-in-out infinite !important;
            z-index: 10 !important;
          }

          @keyframes shimmer {
            0%   { background-position: -600px 0; }
            100% { background-position: 600px 0; }
          }

          .skeleton-cell {
            display: block;
            height: 13px;
            border-radius: 6px;
            background: linear-gradient(
              90deg,
              #f1f5f9 25%,
              #e2e8f0 50%,
              #f1f5f9 75%
            );
            background-size: 600px 100%;
            animation: shimmer 1.4s ease-in-out infinite;
          }

          .skeleton-cell.sk-short  { width: 40%; }
          .skeleton-cell.sk-medium { width: 65%; }
          .skeleton-cell.sk-long   { width: 85%; }
          .skeleton-cell.sk-full   { width: 92%; }

          .skeleton-row td {
            padding: 14px 16px !important;
          }

          .rt-msg-tab-bar {
            display: flex;
            align-items: stretch;
            gap: 4px;
            border-bottom: 2px solid #f1f5f9;
            margin-bottom: 0;
            padding: 8px 4px 0;
            position: relative;
          }

          .rt-msg-tab-btn {
            position: relative;
            display: inline-flex;
            align-items: center;
            gap: 7px;
            border: none;
            background: transparent;
            padding: 9px 16px 11px;
            font-size: 13.5px;
            font-weight: 600;
            color: #64748b;
            cursor: pointer;
            border-radius: 8px 8px 0 0;
            transition: color 0.2s ease, background 0.2s ease;
            outline: none;
            white-space: nowrap;
          }
          .rt-msg-tab-btn i {
            font-size: 13px;
            transition: color 0.2s ease;
          }
          .rt-msg-tab-btn:hover {
            color: #1e293b;
            background: rgba(37,99,235,0.04);
          }
          .rt-msg-tab-btn:focus,
          .rt-msg-tab-btn:focus-visible,
          .rt-msg-tab-btn:active {
            outline: none !important;
            box-shadow: none !important;
            border-color: transparent !important;
          }
          .rt-msg-tab-btn.active {
            color: var(--task-accent, #2563eb);
            font-weight: 700;
            background: var(--task-soft, rgba(37,99,235,0.06)) !important;
          }
          .rt-msg-tab-btn.active i {
            color: var(--task-accent, #2563eb);
          }
          .rt-msg-tab-btn::after {
            content: "";
            position: absolute;
            bottom: -2px;
            left: 0;
            right: 0;
            height: 2px;
            background: var(--task-accent, #2563eb);
            border-radius: 2px 2px 0 0;
            transform: scaleX(0);
            transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
          }
          .rt-msg-tab-btn.active::after {
            transform: scaleX(1);
          }
          .rt-msg-tab-btn.tab-locked .rt-msg-tab-badge {
            background: rgba(245,158,11,0.1);
            color: #b45309;
            border-color: rgba(245,158,11,0.2);
          }
          .rt-msg-tab-badge {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            min-width: 20px;
            height: 20px;
            padding: 0 6px;
            border-radius: 999px;
            font-size: 11px;
            font-weight: 700;
            background: #f1f5f9;
            color: #64748b;
            border: 1px solid #e2e8f0;
            line-height: 1;
            transition: all 0.2s ease;
          }
          .rt-msg-tab-btn.active .rt-msg-tab-badge {
            background: var(--task-soft, rgba(37,99,235,0.1));
            color: var(--task-accent, #1d4ed8);
            border-color: var(--task-accent, rgba(37,99,235,0.2));
          }

          .rt-msg-panel {
            animation: rtMsgTabFadeIn 0.28s cubic-bezier(0.16, 1, 0.3, 1) both !important;
            min-height: 0 !important;
            overflow: visible !important;
            padding-top: 4px !important;
            padding-right: 4px !important;
            scrollbar-width: thin !important;
            scrollbar-color: #94a3b8 #f1f5f9 !important;
          }
          .rt-msg-panel.is-form-panel,
          .rt-msg-panel.is-reply-panel {
            padding-top: 12px !important;
          }
          .rt-msg-panel.is-reply-panel {
            overflow: visible !important;
            max-height: none !important;
          }
          @keyframes rtMsgTabFadeIn {
            from { opacity: 0; transform: translateY(6px); }
            to { opacity: 1; transform: translateY(0); }
          }

          .rt-msg-toolbar {
            display: flex !important;
            justify-content: space-between !important;
            align-items: center !important;
            gap: 12px !important;
            padding: 10px 14px !important;
            background: linear-gradient(90deg, #fafbfd 0%, #ffffff 100%) !important;
            border: 1px solid #e2e8f0 !important;
            border-radius: 10px !important;
            margin-bottom: 12px !important;
          }
          .rt-msg-toolbar-title {
            font-size: 12px !important;
            font-weight: 800 !important;
            color: #334155 !important;
            display: inline-flex !important;
            align-items: center !important;
            gap: 7px !important;
            text-transform: uppercase !important;
            letter-spacing: 0.02em !important;
          }
          .rt-msg-action-btn {
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            gap: 8px !important;
            background: #ffffff !important;
            border: 1px solid #cbd5e1 !important;
            padding: 8px 16px !important;
            border-radius: 8px !important;
            font-size: 13px !important;
            font-weight: 600 !important;
            color: #475569 !important;
            cursor: pointer !important;
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
            outline: none !important;
            white-space: nowrap !important;
            min-width: 120px !important;
            font-family: inherit !important;
          }
          .rt-msg-action-btn:hover {
            background: #f8fafc !important;
            color: #0f172a !important;
            border-color: #94a3b8 !important;
            transform: translateY(-1px) !important;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05) !important;
          }
          .rt-msg-action-btn.is-primary {
            background: var(--task-accent, #2563eb) !important;
            color: #ffffff !important;
            border-color: var(--task-accent, #2563eb) !important;
          }
          .rt-msg-action-btn.is-primary:hover {
            background: var(--task-accent, #2563eb) !important;
            color: #ffffff !important;
            transform: translateY(-1px) !important;
            opacity: 0.9 !important;
            box-shadow: 0 4px 10px -1px var(--task-accent, rgba(37, 99, 235, 0.25)) !important;
          }
          .rt-msg-action-btn.btn-danger-search {
            background: rgba(239, 68, 68, 0.06) !important;
            color: #dc2626 !important;
            border: 1px solid rgba(239, 68, 68, 0.18) !important;
          }
          .rt-msg-action-btn.btn-danger-search:hover {
            background: rgba(239, 68, 68, 0.12) !important;
            color: #b91c1c !important;
            border-color: rgba(239, 68, 68, 0.28) !important;
            transform: translateY(-1px) !important;
            box-shadow: 0 4px 8px -2px rgba(239, 68, 68, 0.12) !important;
          }

          .rt-msg-selected-card {
            display: flex !important;
            align-items: center !important;
            justify-content: space-between !important;
            gap: 20px !important;
            padding: 18px 22px !important;
            margin: 12px 0 !important;
            border: 1px solid rgba(37,99,235,0.12) !important;
            border-radius: 14px !important;
            background: linear-gradient(135deg, rgba(37,99,235,0.04) 0%, rgba(124,58,237,0.03) 100%) !important;
            box-shadow: none !important;
            flex-wrap: wrap !important;
            animation: rtMsgTabFadeIn 0.3s ease both !important;
          }
          .rt-msg-panel.is-reply-panel .rt-msg-selected-card {
            margin: 0 0 12px !important;
          }
          .rt-message-workbench .rt-msg-panel.is-reply-panel .modern-popup-container {
            height: auto !important;
            min-height: 0 !important;
            overflow: visible !important;
          }
          .rt-msg-selected-info {
            display: flex !important;
            align-items: center !important;
            gap: 14px !important;
            min-width: 0 !important;
          }
          .rt-msg-selected-avatar {
            width: 46px !important;
            height: 46px !important;
            border-radius: 12px !important;
            background: linear-gradient(135deg, #2563eb, #7c3aed) !important;
            color: #ffffff !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            font-size: 18px !important;
            font-weight: 800 !important;
            flex-shrink: 0 !important;
            box-shadow: 0 4px 10px rgba(37,99,235,0.2) !important;
            border: 2px solid #ffffff !important;
          }
          .rt-msg-selected-meta {
            display: flex !important;
            flex-direction: column !important;
            gap: 4px !important;
            min-width: 0 !important;
          }
          .rt-msg-selected-meta strong {
            display: block !important;
            color: #1e293b !important;
            font-size: 14px !important;
            font-weight: 700 !important;
            margin-bottom: 3px !important;
          }
          .rt-msg-selected-meta span {
            color: #64748b !important;
            font-size: 12px !important;
            font-weight: 500 !important;
            display: flex !important;
            align-items: center !important;
            gap: 7px !important;
            flex-wrap: wrap !important;
          }
          .rt-msg-selected-actions {
            display: flex !important;
            align-items: center !important;
            gap: 8px !important;
            flex-wrap: wrap !important;
            flex-shrink: 0 !important;
          }
          .rt-msg-selected-actions .rt-msg-action-btn {
            height: 38px !important;
            box-sizing: border-box !important;
            justify-content: center !important;
          }
          .rt-msg-selected-actions .btn-danger-search {
            padding: 8px 12px !important;
            min-width: 38px !important;
          }

          .rt-msg-table-scroll {
            overflow: auto !important;
            max-height: 460px !important;
            position: relative !important;
            scrollbar-width: thin !important;
            scrollbar-color: #94a3b8 #f1f5f9 !important;
            margin-top: 1rem !important;
            border-radius: 0.375rem !important;
          }
          .rt-msg-table-scroll::-webkit-scrollbar {
            width: 8px !important;
            height: 8px !important;
          }
          .rt-msg-table-scroll::-webkit-scrollbar-track {
            background: #f1f5f9 !important;
            border-radius: 999px !important;
          }
          .rt-msg-table-scroll::-webkit-scrollbar-thumb {
            background: linear-gradient(180deg, #cbd5e1 0%, #94a3b8 100%) !important;
            border-radius: 999px !important;
            border: 2px solid #f1f5f9 !important;
          }
          .rt-msg-table-scroll::-webkit-scrollbar-thumb:hover {
            background: linear-gradient(180deg, #94a3b8 0%, #64748b 100%) !important;
          }
          .rt-msg-table {
            width: 100%;
            margin-bottom: 0;
            border: none;
            border-collapse: separate;
            border-spacing: 0;
            color: #1e293b;
          }
          .rt-msg-table thead {
            position: sticky;
            top: 0;
            z-index: 2;
            background: #f8fafc;
          }
          .rt-msg-table thead tr th:first-child {
            border-top-left-radius: 0.375rem !important;
          }
          .rt-msg-table thead tr th:last-child {
            border-top-right-radius: 0.375rem !important;
          }
          .rt-msg-table thead th {
            color: #64748b;
            font-size: 11.5px;
            font-weight: 700;
            letter-spacing: 0.05em;
            text-transform: uppercase;
            padding: 12px 16px;
            border-top: none;
            border-bottom: 1.5px solid #edf2f7;
            white-space: nowrap;
          }
          .rt-message-workbench .rt-msg-table td {
            padding: 14px 16px;
            font-size: 13px;
            color: #334155;
            vertical-align: middle;
            border-top: none;
            border-bottom: 1.5px solid #edf2f7;
            background: transparent !important;
            background-color: transparent !important;
            transition: all 0.15s ease;
          }
          .rt-message-workbench .rt-msg-table tbody tr:last-child td {
            border-bottom: none;
          }
          @keyframes rowFadeIn {
            from { opacity: 0; transform: translateY(4px); }
            to   { opacity: 1; transform: translateY(0); }
          }
          .rt-message-workbench .rt-msg-table tbody tr.rt-msg-row {
            cursor: pointer;
            transition: transform 0.1s ease !important;
            animation: rowFadeIn 0.25s ease both !important;
          }
          .rt-message-workbench .rt-msg-table tbody tr.rt-msg-row:active {
            transform: scaleY(0.98) !important;
          }
          .rt-message-workbench .rt-msg-table tbody tr.rt-msg-row:hover td {
            background-color: rgba(37, 99, 235, 0.04) !important;
            color: #1e293b !important;
          }
          .rt-message-workbench .rt-msg-table tbody tr.rt-msg-row:hover td:first-child {
            box-shadow: inset 3px 0 0 0 rgba(37, 99, 235, 0.35) !important;
          }
          .rt-message-workbench .rt-msg-table tbody tr.rt-msg-row.selected-row td {
            background-color: rgba(37, 99, 235, 0.07) !important;
            color: #1e3a8a !important;
            font-weight: 500 !important;
            border-bottom: 1.5px solid rgba(37, 99, 235, 0.08) !important;
          }
          .rt-message-workbench .rt-msg-table tbody tr.rt-msg-row.selected-row td:first-child {
            box-shadow: inset 4px 0 0 0 #2563eb !important;
          }
          .rt-message-workbench .rt-msg-table tbody tr.rt-msg-row.selected-row:hover td {
            background-color: rgba(37, 99, 235, 0.09) !important;
          }
          .rt-msg-thread-id {
            display: inline-flex;
            align-items: center;
            gap: 6px;
            font-size: 12px;
            font-weight: 600;
            color: var(--text-muted, #64748b);
            white-space: nowrap;
          }
          .rt-msg-row.selected-row .rt-msg-thread-id {
            color: var(--task-accent, #2563eb);
          }
          .rt-msg-author {
            font-weight: 700;
            font-size: 13px;
            color: var(--text-main, #1e293b);
          }
          .rt-msg-email {
            display: inline-flex;
            align-items: center;
            gap: 5px;
            color: var(--text-muted, #64748b);
            font-size: 13px;
            font-weight: 500;
          }
          .rt-msg-time {
            display: inline-flex;
            align-items: center;
            gap: 8px;
            font-size: 12.5px;
            color: var(--text-muted, #64748b);
            font-weight: 500;
            white-space: nowrap;
          }
          .rt-msg-time-icon {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 24px;
            height: 24px;
            border-radius: 6px;
            background: var(--bg-light, #f8fafc);
            color: var(--text-muted, #64748b);
            font-size: 12px;
          }
          .rt-msg-badge-group {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            gap: 6px;
          }
          .rt-msg-badge {
            display: inline-flex;
            align-items: center;
            font-size: 10px;
            font-weight: 700;
            text-transform: uppercase;
            padding: 3px 8px;
            border-radius: 6px;
            letter-spacing: 0.02em;
            border: 1px solid transparent;
          }
          .rt-msg-badge.is-role { background: #f1f5f9; color: #475569; border-color: #e2e8f0; }
          .rt-msg-badge.is-dept { background: #eff6ff; color: #1e40af; border-color: #bfdbfe; }
          .rt-msg-badge.is-partner { background: #fdf2f8; color: #9d174d; border-color: #fbcfe8; }
          .rt-msg-status {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            padding: 4px 10px;
            border-radius: 99px;
            font-size: 11.5px;
            font-weight: 600;
            text-transform: uppercase;
            white-space: nowrap;
          }
          .rt-msg-status.is-unread { background: #fef2f2; color: #e11d48; border: 1px solid #fecdd3; }
          .rt-msg-status.is-read { background: #ecfdf5; color: #059669; border: 1px solid #a7f3d0; }
          .rt-msg-status.is-neutral { background: #f1f5f9; color: #475569; border: 1px solid #e2e8f0; }
          
          @keyframes emptyFadeUp {
            from { opacity: 0; transform: translateY(18px); }
            to   { opacity: 1; transform: translateY(0); }
          }

          .wf-table-empty {
            position: relative;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 56px 24px 48px;
            text-align: center;
            overflow: hidden;
            background: #ffffff;
            border-radius: 16px;
            margin: 12px;
            border: 1.5px solid rgba(37,99,235,0.08);
            animation: emptyFadeUp 0.35s ease both;
          }

          .wf-te-icon-wrap {
            position: relative;
            width: 80px; height: 80px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 24px;
            z-index: 1;
          }

          .wf-te-icon {
            width: 72px; height: 72px;
            border-radius: 16px;
            background: #f8fafc;
            border: 1.5px solid #e2e8f0;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 28px;
            color: #94a3b8;
            position: relative;
            z-index: 2;
          }

          .wf-te-title {
            font-size: 18px;
            font-weight: 800;
            color: #1e293b;
            margin: 0 0 10px 0;
            line-height: 1.3;
          }

          .wf-te-desc {
            font-size: 13.5px;
            color: #64748b;
            margin: 0 0 22px 0;
            line-height: 1.65;
          }

          .wf-name-cell {
            display: flex !important;
            align-items: center !important;
            gap: 10px !important;
            min-width: 190px !important;
          }
          .wf-name-avatar {
            width: 34px !important;
            height: 34px !important;
            border-radius: 10px !important;
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            background: linear-gradient(135deg, rgba(37,99,235,0.12), rgba(20,184,166,0.1)) !important;
            border: 1px solid rgba(37,99,235,0.16) !important;
            color: #1d4ed8 !important;
            font-size: 12px !important;
            font-weight: 800 !important;
            flex-shrink: 0 !important;
          }
          .wf-name-meta {
            display: flex !important;
            flex-direction: column !important;
            gap: 2px !important;
            min-width: 0 !important;
          }
          .wf-name-main {
            font-weight: 700 !important;
            color: #1e293b !important;
            font-size: 13.5px !important;
            line-height: 1.2 !important;
          }
          .selected-row .wf-name-main {
            color: #1e3a8a !important;
          }
          .wf-name-title {
            font-size: 11.5px !important;
            color: #64748b !important;
            font-weight: 500 !important;
            line-height: 1.2 !important;
          }
          .selected-row .wf-name-title {
            color: #64748b !important;
          }
          .wf-empty-value {
            color: #cbd5e1 !important;
            font-size: 11.5px !important;
            font-weight: 500 !important;
            line-height: 1.2 !important;
          }
        `}</style>

        <div className="rt-msg-tab-bar">
          <button
            type="button"
            className={`rt-msg-tab-btn${selectedKey === "home" ? " active" : ""}`}
            onClick={() => handleSelectTab("home")}
          >
            <i className="fa fa-comments" aria-hidden="true" />
            Messages
            <span className="rt-msg-tab-badge">{appMessages.length}</span>
          </button>
          <button
            type="button"
            className={`rt-msg-tab-btn${selectedKey === "msgList" ? " active" : ""}${selectedMsgId === 0 ? " tab-locked" : ""}`}
            onClick={() => handleSelectTab("msgList")}
          >
            <i className="fa fa-reply" aria-hidden="true" />
            View / Reply
            {selectedMsgId > 0 ? (
              <span className="rt-msg-tab-badge">#{selectedMsgId}</span>
            ) : (
              <span className="rt-msg-tab-badge"><i className="fa fa-lock" style={{ fontSize: 9 }} aria-hidden="true" /></span>
            )}
          </button>
          <button
            type="button"
            className={`rt-msg-tab-btn${selectedKey === "profile" ? " active" : ""}`}
            onClick={() => handleSelectTab("profile")}
          >
            <i className="fa fa-plus-circle" aria-hidden="true" />
            Add Message
          </button>
        </div>

        {selectedKey === "home" && (
          <div className="rt-msg-panel">
            {renderSelectedMessageCard()}
            <div className="table-responsive rt-msg-table-scroll">
              <table className="table align-items-center table-flush rt-msg-table">
                <thead>
                  {isLoading && (
                    <tr style={{ height: "0px", padding: 0 }}>
                      <th colSpan={6} style={{ padding: 0, border: "none", height: "0px", position: "relative" }}>
                        <div className="wf-loading-bar" />
                      </th>
                    </tr>
                  )}
                  <tr>
                    <th>
                      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <span>ID</span>
                        {selectedMsgId > 0 && (
                          <span
                            style={{ cursor: "pointer", display: "inline-flex", alignItems: "center" }}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleResetSelection();
                            }}
                            title="Reset Selection"
                          >
                            <i className="fa fa-refresh" style={{ fontSize: "11px", color: "var(--task-accent, #2563eb)" }} aria-hidden="true" />
                          </span>
                        )}
                      </div>
                    </th>
                    <th>Sender</th>
                    <th>Email</th>
                    <th>Role / Department</th>
                    <th>Date & Time</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {isLoading ? (
                    Array.from({ length: 5 }).map((_, i) => (
                      <tr key={`skel-${i}`} className="skeleton-row">
                        <td><span className="skeleton-cell sk-short" style={{ animationDelay: `${i * 0.05}s` }} /></td>
                        <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.06}s` }} /></td>
                        <td><span className="skeleton-cell sk-long" style={{ animationDelay: `${i * 0.07}s` }} /></td>
                        <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.08}s` }} /></td>
                        <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.06}s` }} /></td>
                        <td><span className="skeleton-cell sk-short" style={{ animationDelay: `${i * 0.05}s` }} /></td>
                      </tr>
                    ))
                  ) : appMessages.length === 0 ? (
                    <tr>
                      <td colSpan={6} style={{ padding: 0 }}>
                        <div className="wf-table-empty">
                          <div className="wf-te-icon-wrap">
                            <div className="wf-te-icon">
                              <i className="fa fa-comments-o" aria-hidden="true" />
                            </div>
                          </div>
                          <h3 className="wf-te-title">No Message Threads</h3>
                          <p className="wf-te-desc">Messages sent to or from the applicant will appear here.</p>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    appMessages.map((item, idx) => {
                      const isSelected = selectedMsgId === item.id;
                      return (
                        <tr
                          key={item.id}
                          className={`rt-msg-row ${isSelected ? "selected-row" : ""}`}
                          onClick={() => handleSelectMessage(item)}
                          style={{ animationDelay: `${idx * 0.04}s` }}
                          title={isSelected ? `Click to deselect: Thread #${item.id}` : `Click to select: Thread #${item.id}`}
                        >
                          <td>
                            <span style={{
                              fontWeight: 600,
                              color: isSelected ? "var(--task-accent, #2563eb)" : "#64748b",
                              fontSize: "12px",
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "6px"
                            }}>
                              {isSelected && (
                                <i className="fa fa-check-circle" style={{ fontSize: "12px", color: "var(--task-accent, #2563eb)" }} />
                              )}
                              #{item.id}
                            </span>
                          </td>
                          <td>
                            <div className="wf-name-cell">
                              <span className="wf-name-avatar">
                                {(item.createdBy || "?").split(" ").map(n => n[0]).join("").slice(0, 2).toUpperCase()}
                              </span>
                              <div className="wf-name-meta">
                                <span className="wf-name-main">{item.createdBy || "Unknown Sender"}</span>
                                {item.role ? (
                                  <span className="wf-name-title">{item.role}</span>
                                ) : item.department ? (
                                  <span className="wf-name-title">{item.department}</span>
                                ) : item.partner ? (
                                  <span className="wf-name-title">{item.partner}</span>
                                ) : (
                                  <span className="wf-empty-value">No title</span>
                                )}
                              </div>
                            </div>
                          </td>
                          <td>
                            {item.email ? (
                              <span className="rt-msg-email" title={item.email}>
                                <i className="fa fa-envelope-o" aria-hidden="true" /> {item.email}
                              </span>
                            ) : (
                              <span className="rt-msg-id">N/A</span>
                            )}
                          </td>
                          <td>
                            <div className="rt-msg-badge-group">
                              {item.role && <span className="rt-msg-badge is-role">{item.role}</span>}
                              {item.department && <span className="rt-msg-badge is-dept">{item.department}</span>}
                              {item.partner && <span className="rt-msg-badge is-partner">{item.partner}</span>}
                              {!item.role && !item.department && !item.partner && <span className="rt-msg-id">N/A</span>}
                            </div>
                          </td>
                          <td>
                            <span className="rt-msg-time">
                              <span className="rt-msg-time-icon">
                                <i className="fa fa-calendar-o" aria-hidden="true" />
                              </span>
                              <Moment format="MMM D, YYYY h:mm a">{item.addedDateTime}</Moment>
                            </span>
                          </td>
                          <td>
                            {item.unreadCount > 0 ? (
                              <span className="rt-msg-status is-unread" title={`${item.unreadCount} unread messages`}>
                                {item.unreadCount} New
                              </span>
                            ) : item.readCount > 0 ? (
                              <span className="rt-msg-status is-read" title={`${item.readCount} read messages`}>
                                {item.readCount} Read
                              </span>
                            ) : (
                              <span className="rt-msg-status is-neutral">No Count</span>
                            )}
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {selectedKey === "msgList" && (
          <div className="rt-msg-panel is-reply-panel">
            {selectedMsgId === 0 && (
              <div className="wf-table-empty" style={{ border: "1.5px solid rgba(239, 68, 68, 0.15)", background: "#fffdfd" }}>
                <div className="wf-te-icon-wrap">
                  <div className="wf-te-icon" style={{ background: "#fef2f2", color: "#ef4444", borderColor: "#fee2e2" }}>
                    <i className="fa fa-exclamation-circle" aria-hidden="true" />
                  </div>
                </div>
                <h3 className="wf-te-title" style={{ color: "#991b1b" }}>No Message Selected</h3>
                <p className="wf-te-desc" style={{ color: "#ef4444" }}>Select a message thread from the table before viewing or replying.</p>
                <button className="rt-msg-action-btn" type="button" onClick={() => handleSelectTab("home")} style={{ marginTop: "4px" }}>
                  <i className="fa fa-arrow-left" aria-hidden="true" /> Back to Messages
                </button>
              </div>
            )}
            {selectedMsgId > 0 && (
              <>
                {renderSelectedMessageCard("reply")}
                <MessagingPopup
                  message={selectedMessage}
                  workflowTask={workflowTask}
                  handleReadStatus={handleReadStatus}
                  onClose={() => {
                    handleSelectTab("home");
                  }}
                />
              </>
            )}
          </div>
        )}

        {selectedKey === "profile" && (
          <div className="rt-msg-panel is-form-panel">
            <MsgWithApplicantPopup
              handleAddNewMessage={handleAddNewMessage}
              workflowTask={workflowTask}
              onClose={() => handleSelectTab("home")}
              isLoading={isLoading}
            />
          </div>
        )}
      </div>
    </React.Fragment>
  );
}

export default MessageWithApplicant;
